import type { Filters } from '@/interfaces';
import { PpBreadcrumbs } from '../PpBreadcrumbs';

interface Props {
    hotelName?: string;
    filters: Filters;
}

export const HotelTopBar = ({ hotelName, filters }: Props) => (
    <div className="u-mv16" data-testid="topBar">
        <PpBreadcrumbs hotelName={hotelName} filters={filters} />
    </div>
);
